var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoDropDown is custom made Dropdown component.
 *
 * @author rajeev.k
 * @description This component is an extension of PrimeReact Dropdown tag (<Dropdown/>).
 * All properties of PrimeReact Dropdown can be used by this BeoDropDown component.
 */
import { Dropdown } from "primereact/dropdown";
var BeoDropDown = function (_a) {
    var id = _a.id, _b = _a.width, width = _b === void 0 ? "full" : _b, ref = _a.ref, props = __rest(_a, ["id", "width", "ref"]);
    return (_jsx(Dropdown, __assign({ id: id, ref: ref }, props, { className: "w-".concat(width, " custom-height ").concat(props.className) })));
};
export default BeoDropDown;
